import React from "react";

import Background from "../../../assets/market/market-bg-02.png";
import Image from "../../../assets/market/market-01-choice-a.png";

import GamePageLayout from "../GamePageLayout";

const MarketPage3 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("market-5")}
    >
      장바구니를 챙겨왔는데,
      <br />
      포장재가 다 플라스틱이네.
      <br />
      쓰레기가 너무 많이 나온다...
    </GamePageLayout>
  );
};

export default MarketPage3;
